import { BarChartOutlined } from "@ant-design/icons"
import { Card, Space, Typography } from "antd"

const { Title } = Typography

export interface IAnalyticsTitleProps {
  text: string
}

const AnalyticsTitle = (props: IAnalyticsTitleProps) => {
  const {
    text
  } = props

  return (
    <Card bordered={false} style={{ marginBottom: "1rem" }}>
      <Title level={3} style={{ marginBottom: "0em" }}>
        <Space size={12}>
          <div>
            <BarChartOutlined style={{ color: "rgba(74, 124, 255, 1)" }}/>
          </div>
          {text}
        </Space>
      </Title>
    </Card>
  )
}

export default AnalyticsTitle
